import SearchIcon from "@Icons/SearchIcon";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { MAP_TYPES } from "../../constant";
import { useLocationContext } from "../../locationContext";
import RoadViewMap from "../RoadViewMap";
import StreetViewMap from "../StreetViewMap";
import styles from "./map.module.scss";
import useClickOutside from "hooks/useOutsideClick";
import { useState, useRef, ChangeEvent, useEffect } from "react";
import { isEmptyObject } from "helpers/validations";
import DistanceStripDesktop from "@Pages/Search/components/DesktopMapSection/components/DistanceStripDesktop";
import { getFilteredUniversityFromLocal } from "../../util";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
//

type MapProps = {
  isDesktop: boolean;
  onClick?: any;
  isMapLoaded?: boolean;
  inventory: any;
  onOptionClick?: any;
  insideModal?: boolean;
  showModal?: boolean;
};

const Map = ({
  isDesktop = false,
  onClick,
  isMapLoaded = false,
  inventory,
  onOptionClick,
  insideModal = false,
  showModal,
}: MapProps) => {
  const {
    mapType,
    universities = [],
    distance: distanceObject,
    setDistance,
    regionMarker,
    selectedUniversityFromLocal,
    showDistanceCard,
    setShowDistanceCard,
  } = useLocationContext();
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState("");
  const [secondRender, setSecondRender] = useState(1);

  const [showOptions, setShowOptions] = useState<boolean>(false);
  const ref = useRef(null);

  const filteredOptionsFromLocal = getFilteredUniversityFromLocal(
    universities,
    selectedUniversityFromLocal,
  );
  useEffect(() => {
    if (isDesktop && filteredOptionsFromLocal) {
      const { name } = filteredOptionsFromLocal;
      setValue(name);
    }
  }, [filteredOptionsFromLocal]);
  useEffect(() => {
    if (
      isDesktop &&
      !showDistanceCard &&
      regionMarker.current &&
      typeof regionMarker.current.setMap !== "undefined"
    ) {
      setValue("");
      regionMarker?.current?.setMap(null);
    }
  }, [showDistanceCard]);
  useEffect(() => {
    if (secondRender === 1) {
      setSecondRender(2);
    }
    if (showModal && filteredOptionsFromLocal) {
      onOptionClick(filteredOptionsFromLocal, true);
    }
  }, [showModal, secondRender]);

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    // for desktop
    setValue(e.target.value);
    if (e.target.value === "") {
      regionMarker?.current?.setMap(null);
      setDistance({});
      setShowDistanceCard(false);
    }
    try {
      setShowOptions(true);
      const val = e.target.value;
      const filteredOptions = universities.filter((uni: any) =>
        uni?.name?.toLowerCase()?.includes(val?.toLowerCase()),
      );
      const updatedOptions = filteredOptions.length === 0 ? universities : filteredOptions;
      setOptions(updatedOptions);
    } catch (err) {
      setOptions(universities);
    }
  };

  const handleOptionSelect = (option: any) => {
    // for desktop
    setShowOptions(false);
    onOptionClick(option, true);
    setValue(option?.name);
  };

  useClickOutside(ref, () => setShowOptions(false));

  const { t } = useTranslationHook();

  return (
    <div
      className={formatClassNames(
        styles.mapContainer,
        isDesktop && styles.desktop,
        insideModal && styles.insideModal,
      )}
    >
      {mapType === MAP_TYPES.ROAD_VIEW && (
        <RoadViewMap data={inventory} isMapLoaded={isMapLoaded} />
      )}
      {mapType === MAP_TYPES.STREET_VIEW && <StreetViewMap data={inventory} />}
      {!isDesktop && insideModal && !isEmptyObject(distanceObject) && showDistanceCard && (
        <div className={styles.distanceContainer}>
          <DistanceStripDesktop
            displayText="Distance from the Property"
            selectedDistanceObj={distanceObject}
            setShowDistanceCard={setShowDistanceCard}
            t={t}
          />
        </div>
      )}
      {!isDesktop && !insideModal && (
        <button type="button" className={styles.floatingButton} onClick={onClick}>
          {t("propertypage.components.mapsectionv2.explore")}
        </button>
      )}
      {isDesktop && (
        <>
          <div className={styles.searchInputDesktopContainer} ref={ref}>
            <div className={styles.searchInput} onClick={() => setShowOptions(true)} role="none">
              <SearchIcon fill="#6B7280" />
              <input
                data-testid="Search-University-Input-Field"
                className={styles.searchInputDesktop}
                type="search"
                placeholder={t(
                  "propertypage.components.mapsectionv2.searchforuniversitiesplaceholder",
                )}
                value={value}
                onChange={handleOnChange}
              />
            </div>
            {showOptions && options && options.length > 0 && (
              <div className={styles.optionsDesktop}>
                {options.map((option: any) => (
                  <div
                    className={styles.optionDesktop}
                    key={option.name}
                    onClick={() => handleOptionSelect(option)}
                    role="none"
                  >
                    {option?.name}
                  </div>
                ))}
              </div>
            )}
          </div>
          {!isEmptyObject(distanceObject) && showDistanceCard && (
            <div className={styles.distanceContainer}>
              <DistanceStripDesktop
                displayText="Distance from your Accommodation"
                selectedDistanceObj={distanceObject}
                setShowDistanceCard={setShowDistanceCard}
                t={t}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default wrapperHOC(Map, {
  componentName: "Map",
  showForChina: true,
});
